import { SPLITTER_SIZE } from '../../../../components/SplitPane';

export const DEFAULT_CHART_HEIGHT = 300;
export const FOOTER_HEIGHT = 56;
export const FOOTER_PADDING = 8;
export const SPACER = FOOTER_HEIGHT + FOOTER_PADDING * 2 + SPLITTER_SIZE;
